<template>
  <b-card no-body >
    <b-card-body>
      <span>Tablero de Fertilización</span>
    </b-card-body>
  </b-card>
</template>

<script>

import {BCard, BCardBody,} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
  },
  directives: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss">
</style>
